








































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import LineChartComponent from "@/components/packages/apexcharts/LineChartComponent.vue";
import TempGraphMenuComponent from "@/components/pages/temp_graphs/TempGraphMenuComponent.vue";
import GraphCommentComponent from "@/components/pages/temp_graphs/GraphCommentComponent.vue";
import {
  SensorGraphData,
  SingleGraphData,
  ShowDuration,
  Series
} from "@/typescript/models/sensor/types";
import { ApexOptions } from "apexcharts";
import { MARGIN_VALUE } from "@/config/graph";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
import { TempGraphsData } from "../../../pages/TempGraphsPage.vue";
import isOverThreshold from "../../../typescript/lib/common/is_over_threshold";
import { CategorySideMenuSensor } from "@/components/layout/CategorySideMenuComponent.vue";
import { getEquipmentsApi } from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import { getEquipmentsMeasurementApi } from "@/typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { getEquipmentsMeasurementCsvApi } from "@/typescript/api_client/emesh_api/equipments/equipments_measurement_csv_api";
import { Moment } from "@/typescript/lib/common/moment";
import { GetEquipmentsMeasurementCsvRequest } from "../../../typescript/api_client/emesh_api/equipments/types";
export {
  SensorGraphData,
  ApexOptions,
  SingleGraphData,
  ShowDuration,
  Series,
  TempGraphsData,
  DisplayTime,
  CategorySideMenuSensor,
  GetEquipmentsMeasurementCsvRequest
};

// クラス名で split する際に equipment_id に含まれない文字列としてランダム文字列を付与
const commentCSSName = "over-marker-jaiu207tgxb5";
const apiDateFormat = "YYYYMMDDHHmmss";

@Component({
  components: {
    LineChartComponent,
    TempGraphMenuComponent,
    GraphCommentComponent
  }
})
export default class GraphAreaComponent extends Vue {
  @Prop()
  graphId!: string;

  @Prop({
    default: false
  })
  showDelete!: boolean;

  @Emit()
  delete() {}

  @Prop()
  categorySideMenuSensors!: CategorySideMenuSensor[];

  get internalCategorySideMenuSensors() {
    return this.categorySideMenuSensors;
  }

  set internalCategorySideMenuSensors(
    newCategorySideMenuSensors: CategorySideMenuSensor[]
  ) {
    this.updateGraph();
  }

  tempGraphsData: TempGraphsData[] = [];
  selectedDateUnit: "day" | "week" | "month" = "day";
  currentDate: string = new Moment("YYYY/MM/DD").getFormatDate();
  categories: string[] = Moment.createDatetimes(
    this.currentDate,
    this.selectedDateUnit
  );
  selectedDayTimeFrom: DisplayTime = { HH: "00", mm: "00", ss: "00" };
  selectedDayTimeTo: DisplayTime = { HH: "23", mm: "50", ss: "00" };
  currentColors: string[] = [];
  latestEquipmentsMeasurementApiRequest: GetEquipmentsMeasurementCsvRequest = {
    equipment_id: "",
    since: "",
    until: ""
  };

  // API 取得時の初期表示用判別フラグ
  isInitialDisplay: boolean = false;

  updateGraph() {
    this.$store.commit("setIsGraphLoading", {
      isGraphLoading: true
    });
    const start = new Moment(apiDateFormat, this.currentDate).getStartOf(
      this.selectedDateUnit
    );
    const end = new Moment(apiDateFormat, this.currentDate).getEndOf(
      this.selectedDateUnit
    );
    this.setTempGraphsData(start, end);
  }

  created() {
    this.isInitialDisplay = true;
    const queryStartDate = this.$route.query["start_date"];
    if (queryStartDate) {
      this.currentDate = new Moment(
        "YYYY/MM/DD",
        queryStartDate as string,
        "YYYYMMDD"
      ).getFormatDate();
    }
    this.updateGraph();
    this.$nextTick(() => {
      setTimeout(() => {
        this.$store.commit("setIsGraphLoading", {
          isGraphLoading: false
        });
      }, 500);
    });
  }

  makeSensorGraphData(sensors, since: string, until: string) {
    this.latestEquipmentsMeasurementApiRequest = {
      equipment_id: sensors.map(s => s.equipmentId).join(","),
      since: since,
      until: until
    };
    return Promise.all(
      sensors.map(async sensor => {
        const equipment = await getEquipmentsApi(sensor.equipmentId);
        const equipmentsMeasurementApiRequest = {
          equipment_id: sensor.equipmentId,
          since: since,
          until: until,
          convert_def: 0
        };
        const equipmentMeasurement = await getEquipmentsMeasurementApi(
          equipmentsMeasurementApiRequest
        );
        // 再帰処理の数を最小限に留めたいため、グラフ描画に必要なデータを格納する配列を定義
        const graphData: object[] = [];
        // グラフに描画する温度データを作成
        // X 軸分だけデータを作成し、対象日付のデータが存在しない場合は null を代入する
        const seriesData = this.categories.map((c, index) => {
          const res = equipmentMeasurement.measurement_data.find(
            md =>
              new Moment(
                "YYYY/MM/DD HH:mm",
                md.start_date,
                "YYYYMMDDHHmmss"
              ).roundTenMinutes() === c
          );
          if (res) {
            const temp = isNaN(Number(res.temperature))
              ? null
              : Number(res.temperature);
            graphData[index] = {
              comment: res.comment,
              commentRequired: res.comment_required,
              x: c,
              y: temp,
              rawStartDate: res.start_date
            };
            return temp;
          } else {
            graphData[index] = {
              comment: null,
              commentRequired: null,
              x: c,
              y: null,
              rawStartDate: ""
            };
            return null;
          }
        });

        const series = {
          name: equipment.equipment_name,
          data: seriesData
        };
        return {
          equipmentId: sensor.equipmentId,
          equipmentName: sensor.equipmentName,
          graphColor: this.internalCategorySideMenuSensors.find(
            csms => csms.equipmentId === sensor.equipmentId
          )?.color,
          lowerLimit: equipment.lower_limit,
          graphData: graphData,
          series: series,
          upperLimit: equipment.upper_limit
        };
      })
    );
  }

  async setTempGraphsData(since: string, until: string) {
    setTimeout(() => {
      this.$store.commit("setIsGraphLoading", {
        isGraphLoading: true
      });
    }, 100);
    const checkedStoreSensors = this.internalCategorySideMenuSensors.filter(
      csms => {
        return csms.isChecked;
      }
    );
    this.tempGraphsData = (await this.makeSensorGraphData(
      checkedStoreSensors,
      since,
      until
    )) as TempGraphsData[];
    this.currentColors = this.tempGraphsData.map(tgd => tgd.graphColor);
  }

  changeDate(value: string) {
    this.currentDate = value;
    this.categories = Moment.createDatetimes(value, this.selectedDateUnit);
    const start = new Moment(apiDateFormat, value).getStartOf(
      this.selectedDateUnit
    );
    const end = new Moment(apiDateFormat, value).getEndOf(
      this.selectedDateUnit
    );
    this.setTempGraphsData(start, end);

    if (
      this.internalCategorySideMenuSensors.every(ccs => {
        return !ccs.isChecked;
      })
    ) {
      setTimeout(() => {
        this.$store.commit("setIsGraphLoading", {
          isGraphLoading: false
        });
      }, 100);
    }
  }

  changeDateUnit(event) {
    this.selectedDateUnit = event.target.value;
    this.changeDate(this.currentDate);

    if (
      this.internalCategorySideMenuSensors.every(ccs => {
        return !ccs.isChecked;
      })
    ) {
      setTimeout(() => {
        this.$store.commit("setIsGraphLoading", {
          isGraphLoading: false
        });
      }, 300);
    }
  }

  changeTimePicker() {
    const start = new Moment(
      apiDateFormat,
      `${this.currentDate} ${this.selectedDayTimeFrom.HH}${this.selectedDayTimeFrom.mm}`
    ).getFormatDate();
    const end = new Moment(
      apiDateFormat,
      `${this.currentDate} ${this.selectedDayTimeTo.HH}${this.selectedDayTimeTo.mm}`
    ).getFormatDate();
    this.setTempGraphsData(start, end);

    if (
      this.internalCategorySideMenuSensors.every(ccs => {
        return !ccs.isChecked;
      })
    ) {
      setTimeout(() => {
        this.$store.commit("setIsGraphLoading", {
          isGraphLoading: false
        });
      }, 300);
    }
  }

  changeFrom(value: DisplayTime) {
    this.selectedDayTimeFrom = value;
    const from = `${this.selectedDayTimeFrom.HH}:${this.selectedDayTimeFrom.mm}`;
    const to = `${this.selectedDayTimeTo.HH}:${this.selectedDayTimeTo.mm}`;
    this.categories = Moment.createDatetimes(
      this.currentDate,
      this.selectedDateUnit,
      from,
      to
    );
    this.changeTimePicker();
  }

  changeTo(value: DisplayTime) {
    this.selectedDayTimeTo = value;
    const from = `${this.selectedDayTimeFrom.HH}:${this.selectedDayTimeFrom.mm}`;
    const to = `${this.selectedDayTimeTo.HH}:${this.selectedDayTimeTo.mm}`;
    this.categories = Moment.createDatetimes(
      this.currentDate,
      this.selectedDateUnit,
      from,
      to
    );
    this.changeTimePicker();
  }

  graphThreshold = [{}];
  currentPoints: object[] = [];
  xAxisAnnotations: object[] = [];

  showCommentBox = false;
  commentBoxX = 0;
  commentBoxY = 0;
  registCommentData = {};

  get internalCurrentColors() {
    return this.currentColors;
  }

  get chartOptions(): ApexOptions {
    return {
      chart: {
        id: "chart_id",
        toolbar: {
          show: false
        },
        animations: {
          enabled: false
        },
        events: {
          click: event => {
            const className = event.target.className.baseVal;

            // ユニークなクラス名の event のみコメント入力エリアを出力する
            if (className.includes(commentCSSName)) {
              this.commentBoxX = event.offsetX;
              this.commentBoxY = event.offsetY;
              this.registCommentData = JSON.parse(
                className.split(commentCSSName)[1]
              );
              // コメント必須以外はコメント入力欄を表示しない
              const commentRequired = Number(
                this.registCommentData["comment_required"]
              );
              if (commentRequired === 1) {
                this.showCommentBox = true;
              } else {
                this.showCommentBox = false;
              }
            } else {
              this.showCommentBox = false;
            }
          },
          updated: () => {
            this.$store.commit("setIsGraphLoading", {
              isGraphLoading: false
            });
          },
          mounted: () => {
            this.$store.commit("setIsGraphLoading", {
              isGraphLoading: false
            });
          }
        }
      },
      colors: this.currentColors,
      xaxis: {
        categories: this.categories,
        labels: {
          hideOverlappingLabels: true
        }
      },
      yaxis: {
        max: this.graphMaxVal,
        min: this.graphMinVal
      },
      annotations: {
        xaxis: this.xAxisAnnotations,
        yaxis: this.graphThreshold,
        points: this.currentPoints
      },
      stroke: {
        curve: "smooth"
      }
    };
  }

  get internalGraphData() {
    return this.tempGraphsData;
  }

  get showChart(): boolean {
    const res = this.internalGraphData.length > 0;
    // 初期表示時に「グラフはまだありません」を表示しないようにする対応
    if (res) {
      this.isInitialDisplay = false;
    }
    return res;
  }

  get series() {
    const points: object[] = [];
    const xAxisAnnotations: object[] = [];
    const res = this.internalGraphData.map(igd => {
      let overThresholdRanges: { start?: string; end?: string } = {};
      igd.graphData.forEach((d, index, self) => {
        // 温度が null && overThresholdRange.start がセットされている場合
        // 閾値を超えている場合の境界線を表示する
        if (!d.y && overThresholdRanges.start) {
          overThresholdRanges.end = d.x;
          xAxisAnnotations.push({
            x: overThresholdRanges.start,
            x2: overThresholdRanges.end,
            fillColor: "#ffc1bf",
            opacity: 0.1
          });
          overThresholdRanges = {};
        }
        if (d.y === null) return;
        if (isOverThreshold(d.y, igd.lowerLimit, igd.upperLimit)) {
          const labelImage = d.commentRequired
            ? {
                path:
                  d.y > igd.upperLimit
                    ? "/images/pages/graphs/comment_down.png"
                    : "/images/pages/graphs/comment_up.png",
                width: 30,
                height: 30,
                offsetY: d.y > igd.upperLimit ? -20 : 47
              }
            : {};

          points.push({
            x: d.x,
            y: d.y,
            marker: {
              size: 6,
              fillColor: "#FF0000",
              strokeColor: "#FFF",
              cssClass: `${commentCSSName}{"equipment_id":"${igd.equipmentId}","start_date":"${d.rawStartDate}", "comment_required": "${d.commentRequired}"}`
            },
            image: labelImage
          });
          if (!overThresholdRanges.start) overThresholdRanges.start = d.x;
          // 存在しない添字番号を指定し、参照エラーになるため、チェックする
          const nextItem = self[index >= self.length ? index : index + 1];
          // 次のアイテムが存在しない場合 || 次のアイテムの温度が null の場合 || 次のアイテムの温度が閾値に収まっている場合
          // 閾値を超えている場合の境界線を表示する
          if (
            !nextItem ||
            !nextItem.y ||
            !isOverThreshold(nextItem.y, igd.lowerLimit, igd.upperLimit)
          ) {
            overThresholdRanges.end = d.x;
            xAxisAnnotations.push({
              x: overThresholdRanges.start,
              x2: overThresholdRanges.end,
              fillColor: "#ffc1bf",
              opacity: 0.1
            });
            overThresholdRanges = {};
          }
        }
      });
      return igd.series;
    });
    this.currentPoints = points;
    this.xAxisAnnotations = xAxisAnnotations;
    this.setGraphThreshold();
    return res;
  }

  graphMaxVal = max => {
    return max + MARGIN_VALUE;
  };

  graphMinVal = min => {
    return min - MARGIN_VALUE;
  };

  setGraphThreshold() {
    const thresholdColor: string = "#F0F8FF";
    const thresholdOpacity: number = 0.5;
    // 描画しているセンサの数が 1 台の場合、閾値を描画する
    if (this.internalGraphData.length === 1) {
      const tData: TempGraphsData = this.internalGraphData[0];
      this.graphThreshold.push({
        y: tData.lowerLimit,
        y2: -30,
        fillColor: thresholdColor,
        opacity: thresholdOpacity
      });
      this.graphThreshold.push({
        y: tData.upperLimit,
        y2: 60,
        fillColor: thresholdColor,
        opacity: thresholdOpacity
      });
      return;
    }
    this.graphThreshold = [];
  }

  handleDelete() {
    this.delete();
  }

  commentShowChange(value: boolean) {
    this.showCommentBox = value;
  }

  downloadCsv() {
    getEquipmentsMeasurementCsvApi(this.latestEquipmentsMeasurementApiRequest);
  }
}
